import WarpElement from "@warp-ds/elements-core";
import { trackPageViewEvent } from "../tracking.js";
import { eventReference, TrackingEventMap } from "../../models/trackingEvent.js";

class TrackPageview extends WarpElement {
    declare trackingEventMap: TrackingEventMap;

    static properties = {
        trackingEventMap: { type: Object },
    };

    connectedCallback() {
        super.connectedCallback();
        trackPageViewEvent(this.trackingEventMap[eventReference.FRONTPAGE_PAGE_VIEW]);
    }
}

customElements.define("mfp-track-pageview", TrackPageview as unknown as CustomElementConstructor);
